/** Shared mock session state (avoid circular imports between store and session handler). */
export let mockSession: { userId: string; value: string } | null = null;

export function getMockSession() {
  return mockSession;
}

export function setMockSession(session: { userId: string; value: string } | null) {
  mockSession = session;
}

export function clearMockSession() {
  mockSession = null;
}
